module.exports = __webpack_public_path__ + "static/media/admission_board.932eaa20.svg";